import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import PrivateRoute from './components/main/PrivateRoute';
import { ApiProvider } from './contexts/ApiContext';
import { HelmetProvider } from 'react-helmet-async';

import Logout from './components/auth/Logout';
import Login from './components/auth/Login';
import MainApp from './components/main/MainApp';

//
import Profile from './components/profile/Profile';
import CountdownDashboard from './components/Countdown/Dashboard';
import EditTimer from './components/Countdown/UpdateCoundown';
import CreateTimer from './components/Countdown/CreateCoundown';
import Error from './components/pages/Error';
import Index from './components/home';
import Analytics from './components/Countdown/Analytics';
import Qr from './components/home/qr';
import AnalyticsDashboard from './components/Analytics/Dashboard';
import UploadReport from './components/Analytics/UploadReport';
import ViewReport from './components/Analytics/ViewReport';
import CyclePage from './components/cycle/CyclePage';
import StageBased from './components/cycle/StageBased';
import Strategy from './components/Strategy/StrategyDashboard';
import RawLogs from './components/Countdown/RawLogs';
import BillingManager from './components/Billing/BillingManager';
import DetailedUsageReport from './components/Billing/DetailedUsageReport';


const App = () => {
  const helmetContext = {};
  return (
    <HelmetProvider context={helmetContext}>
      <Router>
        <ApiProvider>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/analytics" element={<Analytics />} />
            <Route path="/qr" element={<Qr />} />
            <Route path="/cycle" element={<PrivateRoute><CyclePage /></PrivateRoute>} />
            <Route path="/login" element={<Login />} />
            <Route path="/logout" element={<Logout />} />
            <Route path='/error' element={<Error />}></Route>
            <Route path='/strategy/stagebased' element={<PrivateRoute><StageBased /></PrivateRoute>}></Route>
            <Route path="/countdown" element={<PrivateRoute><MainApp /></PrivateRoute>} >
              <Route path='/countdown' element={<PrivateRoute><CountdownDashboard /></PrivateRoute>}></Route>
              <Route path='/countdown/createtimer' element={<PrivateRoute><CreateTimer /></PrivateRoute>}></Route>
              <Route path='/countdown/analytics' element={<PrivateRoute><Analytics /></PrivateRoute>}></Route>
              <Route path='/countdown/analytics/logs' element={<PrivateRoute><RawLogs /></PrivateRoute>}></Route>
              <Route path='/countdown/edittimer/:id' element={<PrivateRoute><EditTimer /></PrivateRoute>}></Route>
              <Route path='/countdown/edittimer/:id' element={<PrivateRoute><EditTimer /></PrivateRoute>}></Route>
              <Route path='/countdown/billing' element={<PrivateRoute><BillingManager /></PrivateRoute>}></Route>
              <Route path='/countdown/billing/report/:year/:month' element={<PrivateRoute><DetailedUsageReport /></PrivateRoute>}></Route>
            </Route>
            <Route path="/strategy" element={<PrivateRoute><MainApp /></PrivateRoute>} >
              <Route path='/strategy' element={<PrivateRoute><Strategy /></PrivateRoute>}></Route>
            </Route>
            <Route path="/analytics" element={<PrivateRoute><MainApp /></PrivateRoute>} >
              <Route path='/analytics' element={<PrivateRoute><AnalyticsDashboard /></PrivateRoute>}></Route>
              <Route path='/analytics/upload' element={<PrivateRoute><UploadReport /></PrivateRoute>}></Route>
              <Route path='/analytics/report/:id' element={<PrivateRoute><ViewReport /></PrivateRoute>}></Route>
            </Route>
            <Route path="/profile" element={<PrivateRoute><MainApp /></PrivateRoute>} >
              <Route path='/profile' element={<PrivateRoute><Profile /></PrivateRoute>}></Route>
            </Route>
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </ApiProvider>
      </Router>
    </HelmetProvider>
  );
};

export default App;
